import type { z } from 'zod';

/** Código de programa/fornecedor: IATA da companhia (aéreo), Sabre chain code
 *  (hotel) ou código de locadora (carro). Dois caracteres, caixa alta,
 *  alfanumérico — o mesmo prefixo que a Sabre exige em
 *  `FrequentFlyerNumber`/`LoyaltyId`. */
export const LOYALTY_CODE = /^[A-Z0-9]{2}$/;

/** Código de programa de HOTEL ou de LOCADORA gravado: o código da Sabre (2 chars,
 *  vai à Sabre) OU a chave própria de 3–12 chars de um programa que a Sabre não
 *  conhece (Atlantica, Movida…) — só guardamos o número. O comprimento é o que
 *  distingue: `isSabreChainCode` decide o que pode virar `LoyaltyId`. */
export const SUPPLIER_LOYALTY_CODE = /^[A-Z0-9]{2,12}$/;

export function isSabreChainCode(code: string): boolean {
  return LOYALTY_CODE.test(code);
}

/** `.superRefine` para listas: um código repetido é uma linha ambígua (qual
 *  número mandar para a Sabre?), então é 400 na borda, nunca "o último vence". */
export function uniqueCodes<T>(pick: (row: T) => string, field: string) {
  return (rows: T[], ctx: z.RefinementCtx): void => {
    const seen = new Set<string>();
    rows.forEach((row, i) => {
      const code = pick(row);
      if (seen.has(code)) {
        ctx.addIssue({ code: 'custom', path: [i, field], message: `duplicate ${field}` });
      }
      seen.add(code);
    });
  };
}
